/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Csat_HighInputs */

const en_us2_engagement_csat_high = /** @type {(inputs: Engagement_Csat_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Great`)
};

const pt_br2_engagement_csat_high = /** @type {(inputs: Engagement_Csat_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ótimo`)
};

const es_419_engagement_csat_high = /** @type {(inputs: Engagement_Csat_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excelente`)
};

const pt_pt2_engagement_csat_high = /** @type {(inputs: Engagement_Csat_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ótimo`)
};

const fr_fr2_engagement_csat_high = /** @type {(inputs: Engagement_Csat_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excellent`)
};

const de_de2_engagement_csat_high = /** @type {(inputs: Engagement_Csat_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Super`)
};

const it_it2_engagement_csat_high = /** @type {(inputs: Engagement_Csat_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benissimo`)
};

/**
* | output |
* | --- |
* | "Great" |
*
* @param {Engagement_Csat_HighInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_csat_high = /** @type {((inputs?: Engagement_Csat_HighInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Csat_HighInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_csat_high(inputs)
	if (locale === "es-419") return es_419_engagement_csat_high(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_csat_high(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_csat_high(inputs)
	if (locale === "de-DE") return de_de2_engagement_csat_high(inputs)
	if (locale === "it-IT") return it_it2_engagement_csat_high(inputs)
	return en_us2_engagement_csat_high(inputs)
});
export { engagement_csat_high as "engagement.csat_high" }